module.exports = __webpack_public_path__ + "static/img/vip-card.92393cb8.png";